/* eslint-disable camelcase */
/* @flow strict */

import _ from 'lodash';

const validateTicketLevels = (data: any, scrollCb: (HTMLElement) => void): boolean => {
  const defaultNodeEl = {
    style: {}
  };

  const tickets = data.tickets || data.items;

  const validItems = _.map(tickets, (t: {}, i: number): boolean => {
    let isValid = true;

    const el = document.querySelector(`.TicketLevelItem[data-tli="${_.get(t, 'temp_id', t.id)}"]`);

    if (!el) {
      console.warn(
        'document.querySelector(`.TicketLevelItem[data-tli="${_.get(t, \'temp_id\', t.id)}"]`) is not defined'
      );
      return true;
    }

    const name = el.querySelector(`input.form-control[id="ticketName-${i}"]`);
    const nameVMsg = name.nextSibling || defaultNodeEl;

    const price = el.querySelector(`input.form-control[id="ticketPrice-${i}"]`);
    const priceVMsg = price.parentNode.nextSibling || defaultNodeEl;

    const quantity = el.querySelector(`input.form-control[id="ticketQuantity-${i}"]`);
    const quantityVMsg = quantity.nextSibling || defaultNodeEl;

    const minimumQuantity = el.querySelector(`input.form-control[id="Minimum_tickets_required-${i}"]`);
    const maximumQuantity = el.querySelector(`input.form-control[id="Maximum_tickets_required-${i}"]`);

    const ticketSoldQuantity = data.current_inventory?.find((x: any): any => x.ticket_id === t.id)?.sold_quantity;

    let invalidEl = null;

    if (!_.size(_.trim(t.name))) {
      name.classList.add('validationElement');
      nameVMsg.style.display = 'block';

      invalidEl = name;

      isValid = false;
    } else {
      name.classList.remove('validationElement');
      nameVMsg.style.display = 'none';
    }

    if (!_.size(_.trim(t.price))) {
      price.classList.add('validationElement');
      priceVMsg.style.display = 'block';

      invalidEl = price;

      isValid = false;
    } else {
      price.classList.remove('validationElement');
      priceVMsg.style.display = 'none';
    }

    if (!_.size(_.trim(t.stock_quantity))) {
      console.log('t.stock_quantity');
      quantity.classList.add('validationElement');
      quantityVMsg.textContent = 'This field is required.';
      quantityVMsg.style.display = 'block';

      invalidEl = quantity;

      isValid = false;
    } else if (+t.stock_quantity < ticketSoldQuantity) {
        quantity.classList.add('validationElement');
        // eslint-disable-next-line max-len
        quantityVMsg.textContent = `Your ticket quantity has to be equal or greater than the number of tickets you already sold, which is ${ticketSoldQuantity}.`;
        quantityVMsg.style.display = 'block';

        invalidEl = quantity;

        isValid = false;
      } else {
        quantity.classList.remove('validationElement');
        quantityVMsg.style.display = 'none';
      }

    if (!!minimumQuantity) {
      const minimumQuantityVMsg = minimumQuantity.nextSibling || defaultNodeEl;

      if ((+t.order_min_quantity > +t.order_max_quantity) || (+t.default_ticket_quantity !== 0 ? +t.order_min_quantity > +t.default_ticket_quantity : false)) {
        minimumQuantity.classList.add('validationElement');
        minimumQuantityVMsg.style.display = 'block';

        invalidEl = minimumQuantity;

        isValid = false;
      } else {
        minimumQuantityVMsg.style.display = 'none';
        minimumQuantity.classList.remove('validationElement');
      }
    }

    if (!!maximumQuantity) {
      const maximumQuantityVMsg = maximumQuantity.nextSibling || defaultNodeEl;

      if (+t.order_max_quantity < +t.default_ticket_quantity) {
        maximumQuantityVMsg.style.display = 'block';
        maximumQuantity.classList.add('validationElement');

        invalidEl = maximumQuantity;

        isValid = false;
      } else {
        maximumQuantityVMsg.style.display = 'none';
        maximumQuantity.classList.remove('validationElement');
      }
    }

    // TODO: SC-1344 I should be able to save an end ticket sales time that is after the start time
    // if (t.is_set_sale_time) {
    //   const endDate = el.querySelector(`#te_endDate-${i} input`);
    //   const endDateVMsg = el.querySelector(`#te_endDateValidationMsg-${i}`);
    //
    //   if (Date.parse(t.sale_end_time_utc) > Date.parse(data.end_time_utc)) {
    //     endDate.classList.add('validationElement');
    //     endDateVMsg.style.display = 'block';
    //
    //     invalidEl = endDate;
    //
    //     isValid = false;
    //   }
    // }

    if (scrollCb) {
      scrollCb(invalidEl);
    }

    return isValid;
  });

  return !_.some(validItems, (i: {}): boolean => i === false);
};

export default validateTicketLevels;
